const PROD_ALLOWED_COMPANY_IDS =
	import.meta.env.VITE_STAGE === "production" ? new Set([162]) : new Set();

const ALLOWED_COMPANY_IDS =
	import.meta.env.VITE_STAGE === "test"
		? new Set([1, 2])
		: PROD_ALLOWED_COMPANY_IDS;

export function isTestingCAFeatureEnabled(companyId) {
	return ALLOWED_COMPANY_IDS.has(companyId);
}
